/** Public URL paths (production domain applied in SEO/schema). */
export const LOGO_SRC = '/logo.webp';
export const LOGO_SRC_192 = '/logo-192.webp';
